#import "../fragments/source-fragment.graphql"

mutation DeleteSource($source: SourceDeleteInput!) {
    sourceDelete(input: $source) {
        source {
            ...SourceFragment
        }
    }
}
